/// <reference path="../../app.definition.ts" />

import { FormField } from "./formField";
import { Serializable } from "./Serializable";

export class FormSection implements Serializable<FormSection> {
    id: number;
    type: string;
    sectionId: number;
    index: number;
    title: string;
    required: boolean; //is the whole section required
    fields: FormField[];
    sections: FormSection[];
    displayType: string;
    closeOthers: boolean;

    constructor(input?: any) {
        !!input && (this.deserialize(input));
    }

    deserialize(input: any) {
        input.id && (this.id = input.id);
        input.type && (this.type = input.type);
        input.title && (this.title = input.title);
        this.required = input.required || false;
        input.displayType && (this.displayType = input.displayType);
        this.closeOthers = input.closeOthers;

        if (!!input.sections) {
            this.sections = [];
            for (let sectionDef of input.sections) {
                this.sections.push(new FormSection(sectionDef));
            }
        } else {
            delete this.sections;
        }

        if (!!input.fields) {
            this.fields = [];
            for (let fieldDef of input.fields) {
                this.fields.push(new FormField(fieldDef));
            }
        } else {
            delete this.fields;
        }

        return this;
    }
}
